import PolicyholderPageWrapperPublic from '@root/account/src/components/policyholder-page-wrapper-public';
import PropTypes from '@root/vendor/prop-types';
import React, { lazy } from '@root/vendor/react';
import environment from '@root/core/src/utils/environment';
import { ACCOUNT_APP_DOMAIN } from '@root/account.joinroot.com/src/app-entry';
import { Redirect, Route, Switch } from '@root/core/src/components/route';

const LoginEntry = lazy(() => import(/* webpackChunkName: "login" */ '@root/login/src/login-entry'));
const PasswordResetEntry = lazy(() => import(/* webpackChunkName: "password-reset" */ '@root/password-reset/src/password-reset-entry'));
const SplashEntry = lazy(() => import(/* webpackChunkName: "openOnPhone" */ '@root/splash/src/splash-entry'));
const IntentEntry = lazy(() => import(/* webpackChunkName: "intent" */ '@root/intent/src/intent-entry'));
const CloseWebViewEntry = lazy(() => import(/* webpackChunkName: "intent" */ '@root/web-view/src/close-web-view-entry'));
const ContactSupportEntry = lazy(() => import(/* webpackChunkName: "contact-support" */ '@root/contact-support/src/contact-support-entry'));
const UploadSessionEntry = lazy(() => import(/* webpackChunkName: "upload-session" */ '@root/upload-session/src/upload-session-entry'));

export default function PublicRouter({ passProps }) {
  return (
    <Switch>
      <Route
        path={'/login/password'}
        render={() => {
          return (
            <PolicyholderPageWrapperPublic>
              <LoginEntry
                domain={ACCOUNT_APP_DOMAIN}
                isModuleInPath={false}
                module={'account.joinroot.com'}
                passProps={passProps}
              />
            </PolicyholderPageWrapperPublic>
          );
        }}
      />
      <Route
        path={'/password-reset'}
        render={() => <PasswordResetEntry passProps={passProps} />}
      />
      <Route
        path={'/splash'}
        render={() => <SplashEntry passProps={{}} />}
      />
      <Route
        path={'/intent'}
        render={() => <IntentEntry passProps={{}} />}
      />
      <Route
        path={'/contact-support'}
        render={() => <ContactSupportEntry passProps={{}} />}
      />
      <Route
        path={'/close-web-view'}
        render={() => <CloseWebViewEntry passProps={{}} />}
      />
      {!!environment.isUploadSessionFlowEnabled &&
        <Route
          path={'/upload-session'}
          render={() => <UploadSessionEntry />}
        />
      }
      <Redirect to={'/login/password'} />
    </Switch>
  );
}

PublicRouter.propTypes = {
  passProps: PropTypes.object.isRequired,
};
